// Utilities
import { createSimpleFunctional } from "../../util/index.mjs";
export const VListImg = createSimpleFunctional('v-list-img');
//# sourceMappingURL=VListImg.mjs.map